import {Method} from 'axios';

export enum ApiActionTypes {
  API_CALL = 'API_CALL',
  API_START = 'API_START',
  API_END = 'API_END',
  ACCESS_DENIED = 'ACCESS_DENIED',
  API_ERROR = 'API_ERROR',
}

export type ApiActionCall = {
  type: typeof ApiActionTypes.API_CALL;
  payload: {
    url: string;
    method: Method;
    data?: any;
    token?: string;
    useAuthorization?: boolean;
    onSuccess: (data: any) => any; //((dispatch: Dispatch<Action>) => void) | Action;
    onFailure: (error: any) => any; //((dispatch: Dispatch<Action>) => void) | Action;
    label: string;
  };
};

interface ApiAccessDeniedAction {
  type: typeof ApiActionTypes.ACCESS_DENIED;
  payload: {
    url: string;
  };
}

interface ApiErrorAction {
  type: typeof ApiActionTypes.API_ERROR;
  error: string;
}

interface ApiStartAction {
  type: typeof ApiActionTypes.API_START;
  payload: string;
}

interface ApiEndAction {
  type: typeof ApiActionTypes.API_END;
  payload: string;
}

export const apiStart = (label: string): ApiStartAction => ({
  type: ApiActionTypes.API_START,
  payload: label,
});

export const apiEnd = (label: string): ApiEndAction => ({
  type: ApiActionTypes.API_END,
  payload: label,
});

export const accessDenied = (url: string): ApiAccessDeniedAction => ({
  type: ApiActionTypes.ACCESS_DENIED,
  payload: {
    url,
  },
});

export const apiError = (error: string): ApiErrorAction => ({
  type: ApiActionTypes.API_ERROR,
  error,
});
